import { render } from "./Sv008.vue?vue&type=template&id=4e23ab2e&scoped=true"
import script from "./Sv008.vue?vue&type=script&lang=js"
export * from "./Sv008.vue?vue&type=script&lang=js"

import "./Sv008.vue?vue&type=style&index=0&id=4e23ab2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e23ab2e"]])

export default __exports__